module.exports = __webpack_public_path__ + "img/dex.1df65a72.svg";